// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"t2-z"};